import type { ReportDataSource, ReportSpec } from 'src/components/star-grid/api/reportEngineTypes';
import type { StudioTemplate } from 'src/components/star-grid/reportStudio.types';

/** What the shelves add to a dataset report's source: its measure. */
export type DataSourceChoices = Omit<ReportDataSource, 'id'>;

/** Keys a report saved while Combine Datasources existed may still carry; nothing can show or edit them now. */
const RETIRED_KEYS = new Set(['with', 'formulas']);
const withoutBlend = (dataset: ReportDataSource): ReportDataSource =>
  Object.fromEntries(Object.entries(dataset).filter(([key]) => !RETIRED_KEYS.has(key))) as unknown as ReportDataSource;

/**
 * The shelves' current data source as a spec patch: a dataset id when on a dataset, or a cleared
 * `dataset` when on P&L. A matching existing dataset keeps its extra fields (e.g. query); the
 * shelves' own choices replace the saved ones.
 */
export const specDataSource = (
  spec: ReportSpec | undefined,
  datasetId: string | undefined,
  choices: DataSourceChoices = {}
): Pick<ReportSpec, 'dataset'> =>
  datasetId
    ? {
        dataset: {
          ...(spec?.dataset?.id === datasetId ? withoutBlend(spec.dataset) : {}),
          id: datasetId,
          measure: choices.measure
        }
      }
    : { dataset: undefined };

/** True when the template's dataset is not in its own catalog, so the editor has nothing to resolve it against. */
export const isTemplateDatasetMissing = (template: StudioTemplate | undefined): boolean =>
  Boolean(template && !template.catalog.datasets.some((dataset) => dataset.id === template.definition.dataset_id));
